import clsx from 'clsx';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { AsyncComponent } from '@headless-workspace/domain/common/server';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { PRODUCT_DETAIL_RATING_SECTION_ID, RatingsAndReviewsContent } from '../../../../../src/client';
import { RatingsAndReviewsValue } from './RatingsAndReviewsValue';
import { getMemoReviewsWithSorting } from './cache';

type ProductDetailRatingsAndReviewsSectionProps = PropsWithLocale & {
    rating: number;
    productId: string;
};

const MAX_RATING = 5;

const INIT_REVIEW_WITH_SORTING: RatingsAndReviewsValue = {
    reviewCount: 0,
    reviews: [],
    sortingOptions: [],
    ratingFilter: [],
};

export const ProductDetailRatingsAndReviewsSection: AsyncComponent<
    ProductDetailRatingsAndReviewsSectionProps
> = async ({ rating, productId, locale }) => {
    const reviewsWithSortingResult = await getMemoReviewsWithSorting(locale, productId);

    const { reviewCount, reviews, ratingFilter, sortingOptions } =
        unwrapResultSuccess(reviewsWithSortingResult) ?? INIT_REVIEW_WITH_SORTING;

    return (
        <section
            id={PRODUCT_DETAIL_RATING_SECTION_ID}
            className={clsx(
                'flex flex-col',
                'py-1.5 px-1 desktop:px-5.5 gap-2.5',
                'scroll-mt-headerFixed tablet:scroll-mt-headerFixedTablet desktopS:scroll-mt-headerFixedMainDesktop desktop:scroll-mt-headerDesktop',
            )}
        >
            <RatingsAndReviewsContent
                ratingFilter={ratingFilter}
                rating={rating}
                baseReviews={reviews}
                reviewCount={reviewCount}
                maxRating={MAX_RATING}
                sortingOptions={sortingOptions}
                productId={productId}
                locale={locale}
            />
        </section>
    );
};
